// Do not redirect from an auth page or when checking getUserByToken
export const checkIfCanRedirect = (url?: string) =>
  url ? !/^\/api\/user\/(?:token|getUserByToken)$/.test(url) : true;
